// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Collection from './Collection';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Collection);
